import axios from "axios";
import {catchApiErrors} from "../helpers/utils";

class apiClass {
    processingRequests = {}

    addProcessingRequest(identifier) {
        this.processingRequests[identifier] = axios.CancelToken.source()
        return this.processingRequests[identifier]
    }

    stopProcessingRequest(identifier) {
        //Check if there are any previous pending requests
        if (this.processingRequests[identifier]) {
            this.processingRequests[identifier].cancel("Operation canceled due to new request.")
            delete this.processingRequests[identifier]
        }
    }

    prefixUrl = function (resource) {
        return `/api/${resource}`;
    }

    formatUrl = function (params) {
        return `${this.prefixUrl(params.resource)}${(params && params.id ? ('/' + params.id) : '')}${params.action ? '/' + params.action : ''}`
    }

    serialize(obj, prefix) {
        let str = [],
            p;
        for (p in obj) {
            if (obj.hasOwnProperty(p)) {
                const k = prefix ? prefix + "[" + p + "]" : p,
                    v = obj[p];

                if (v === null)
                    continue;

                str.push((typeof v === "object") ?
                    this.serialize(v, k) :
                    encodeURIComponent(k) + "=" + encodeURIComponent(v));
            }
        }
        return str.join("&");
    }

    constructor() {
        this.axiosInstance = axios.create({
            withCredentials: true // required to handle the CSRF token
        });

        this.axiosInstance.interceptors.response.use(function (response) {
            // Any status code that lie within the range of 2xx cause this function to trigger
            // Do something with response data
            return response;
        }, function (error) {
            // Any status codes that falls outside the range of 2xx cause this function to trigger
            // Do something with response error

            if (error.response) {
                if (error.response.status === 401) {
                    localStorage.removeItem('user');
                    window.location.href = '/login';
                } else
                    catchApiErrors(error);
            }

            return Promise.reject(error);
        });

    }

    get(resource, params, action = null, config = {}, identifier = null) {

        if (identifier) {
            this.stopProcessingRequest(identifier)
            config.cancelToken = this.addProcessingRequest(identifier).token
        }


        const resourceId = params && params.id ? params.id : null;
        if (params && params.hasOwnProperty('id'))
            delete params.id;

        const getParams = this.serialize(params);

        return this.axiosInstance.get(this.formatUrl({
            resource: resource,
            id: resourceId,
            action: action
        }) + (getParams ? ('?' + getParams) : ''), config);
    }

    post(resource, params, action = null, config = {}) {
        return this.axiosInstance.post(this.formatUrl({
            resource: resource,
            id: params && params.id ? params.id : null,
            action: action
        }), params, config);
    }

    patch(resource, params, action = null, config = {}) {
        return this.axiosInstance.patch(this.formatUrl({
            resource: resource,
            id: params && params.id ? params.id : null,
            action: action
        }), params, config);
    }

    save(resource, params, action = null, config = {}) {
        if (params.id)
            return this.patch(resource, params, action, config);

        return this.post(resource, params, action, config);
    }

    remove(resource, id, action = null, config = {}) {
        return this.axiosInstance.delete(this.formatUrl({
            resource: resource,
            id: id,
            action: action
        }), config);
    }
}

const api = new apiClass();

export default api;